import Location from "screens/private/location";
export default Location;
